<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="600px" persistent>
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>{{ action }} Call for Monetization</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col> </v-col>
        <v-card-text style="max-height: 700px">
          <v-form ref="MonetizationCallFormref" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="purpose"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    required
                    label="Purpose"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-menu
                    ref="dateFromMenu"
                    :close-on-content-click="false"
                    :return-value.sync="date_from"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        color="#6DB249"
                        dense
                        v-model="date_from"
                        :rules="[formRules.required]"
                        chips
                        small-chips
                        label="Date (FROM)"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date_from"
                      no-title
                      :min="nowDate"
                      scrollable
                      color="#6DB249"
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="$refs.dateFromMenu.save(date_from)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-menu
                    ref="dateToMenu"
                    :close-on-content-click="false"
                    :return-value.sync="date_to"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        color="#6DB249"
                        dense
                        v-model="date_to"
                        :rules="[formRules.required]"
                        chips
                        small-chips
                        label="Date (TO)"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date_to"
                      no-title
                      :min="date_from ? date_from : null"
                      scrollable
                      color="#6DB249"
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="$refs.dateToMenu.save(date_to)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-switch
                    @change="selectAllEmp"
                    v-model="isSelectAll"
                    label="Select All Employees"
                  ></v-switch>
                  <v-autocomplete
                    outlined
                    dense
                    :rules="[formRules.required]"
                    label="Employee/s"
                    v-model="selectedUser"
                    :items="users"
                    item-text="name"
                    item-value="id"
                    required
                    class="rounded-lg"
                    color="#6DB249"
                    deletable-chips
                    multiple
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="action == 'Add'" class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
          <v-btn color="#519043" class="white--text" @click="add()">
            <v-icon>mdi-check-circle</v-icon>
            Save Details
          </v-btn>
        </v-card-actions>

        <v-card-actions v-if="action == 'Update'" class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
          <v-btn
            v-if="edit"
            color="#519043"
            class="white--text"
            @click="update()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Update Details
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
  },
  data() {
    return {
      dialog: false,
      id: null,
      purpose: null,
      date_from: null,
      date_to: null,
      officeList: [],
      isSelectAll: false,
      selectedUser: [],
      userID: null,
      edit: false,
      users: [],

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      nowDate: new Date().toISOString().slice(0, 10),
    };
  },
  watch: {
    data: {
      handler(data) {
        this.getUsers();
        this.dialog = true;

        if (data.id != null) {
          this.isSelectAll = data.isAll;
          this.id = data.id;
          this.edit =
            this.$store.state.user.id == data.created_by ? true : false;
          this.purpose = data.purpose;
          this.date_from = data.date_from;
          this.date_to = data.date_to;
          this.selectedUser = data.called_users;
        } else {
          this.purpose = null;
          this.date_from = null;
          this.date_to = null;
          // this.$refs.MonetizationCallFormref.reset();
        }
      },
      deep: true,
    },
    selectedUser: {
      handler(data) {
        if (this.users.length != 0) {
          if (data.length == this.users.length) {
            this.isSelectAll = true;
          } else {
            this.isSelectAll = false;
          }
        } else {
          this.isSelectAll = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.selectedUser = [];
      this.isSelectAll = false;
      this.eventHub.$emit("closeMonetizationCallDialog", false);
    },
    selectAllEmp() {
      if (this.isSelectAll == true) {
        this.selectedUser = [];
        for (let i = 0; i < this.users.length; i++) {
          this.selectedUser.push(this.users[i].id);
        }
      } else {
        this.selectedUser = [];
      }
    },
    getUsers() {
      this.axiosCall(
        "/monetization-call/getEmployeeForMonitization",
        "GET"
      ).then((res) => {
        this.users = res.data;
      });
    },

    add() {
      if (this.$refs.MonetizationCallFormref.validate()) {
        let data = {
          purpose: this.purpose,
          called_users: this.selectedUser,
          date_from: this.date_from,
          isAll: this.isSelectAll,
          date_to: this.date_to,
        };
        // console.log(data);
        this.axiosCall("/monetization-call", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.close();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
    update() {
      if (this.$refs.MonetizationCallFormref.validate()) {
        let data = {
          purpose: this.purpose,
          called_users: this.selectedUser,
          date_from: this.date_from,
          isAll: this.isSelectAll,
          date_to: this.date_to,
        };
        this.axiosCall("/monetization-call/" + this.id, "PATCH", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.close();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      }
    },
  },
};
</script>
